import React from 'react';

import styles from './styles.module.scss';

const IPBlockedPage = () => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <h1 className={styles.title}>
                    🔒 Access Restricted
                </h1>
                <p className={styles.subtitle}>
                    Your IP address is not whitelisted for this account.
                    <br />
                    Please contact your administrator to add your IP address to the whitelist.
                </p>
            </div>
        </div>
    );
};

export default IPBlockedPage;

